'use strict';
import * as $j_app$002e$002dEndpoints$0024 from "./app.-Endpoints$.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData from "./app.data.-App-Auth-Data.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024 from "./app.data.-App-Auth-Data$.js";
import * as $j_app$002ewebclient$005fprelude$002eexts$002e$002dCookie$002dApp$002dAuth$002dData$002dExts$0024package$0024 from "./app.webclient_prelude.exts.-Cookie-App-Auth-Data-Exts$package$.js";
import * as $j_app$002ewebclient$005fprelude$002eexts$002e$002dFirebase$002dUser$002dExts$0024package$0024 from "./app.webclient_prelude.exts.-Firebase-User-Exts$package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppUser(firebase) {
  this.Fm = null;
  this.Fm = firebase;
}
export { $c_Lapp_data_AppUser as $c_Lapp_data_AppUser };
$p = $c_Lapp_data_AppUser.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppUser;
/** @constructor */
function $h_Lapp_data_AppUser() {
}
export { $h_Lapp_data_AppUser as $h_Lapp_data_AppUser };
$h_Lapp_data_AppUser.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppUser)) {
    var x = this.Fm;
    var x$2 = x$0.Fm;
    return (x === x$2);
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "AppUser";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Fm;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "firebase";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.bqy = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_AOrNullExts$package$().asV(this.Fm.XJ.displayName);
});
$p.arD = (function() {
  var this$1 = this.bqy();
  if (this$1.c()) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  } else {
    var arg1 = this$1.g();
    var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().fw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(arg1, "\\s+", 0));
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().aO(this$3);
  }
  return $x_1;
});
$p.ah6 = (function() {
  var this$6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$();
  var fut = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$().fs(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_app$002ewebclient$005fprelude$002eexts$002e$002dFirebase$002dUser$002dExts$0024package$0024.$m_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$().bsE(this.Fm.XJ).btt(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2) => {
    $j_app$002edata$002e$002dApp$002dAuth$002dData$0024.$m_Lapp_data_AppAuthData$();
    return new $j_app$002edata$002e$002dApp$002dAuth$002dData.$c_Lapp_data_AppAuthData(_$2);
  })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_prelude\uff3fclient$package$().arw()))));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcats_effect_kernel_Async__fromFuture__O__O(this$6.dn, fut);
});
$p.bwy = (function() {
  return this.ah6().ky(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((data) => new $j_app$002e$002dEndpoints$0024.$c_Lapp_data_CookieAppAuthData(($j_app$002e$002dEndpoints$0024.$m_Lapp_data_CookieAppAuthData$(), data))))).jf(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((authData) => {
    var authData$1 = ((authData === null) ? null : authData.oU);
    return $j_app$002ewebclient$005fprelude$002eexts$002e$002dCookie$002dApp$002dAuth$002dData$002dExts$0024package$0024.$m_Lapp_webclient\uff3fprelude_exts_CookieAppAuthDataExts$package$().bvt(authData$1).auT($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$().dn).ky(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var $x_1;
      var $x_1 = authData$1;
      return new $j_app$002e$002dEndpoints$0024.$c_Lapp_data_CookieAppAuthData($x_1);
    })));
  })));
});
function $isArrayOf_Lapp_data_AppUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j9)));
}
export { $isArrayOf_Lapp_data_AppUser as $isArrayOf_Lapp_data_AppUser };
var $d_Lapp_data_AppUser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUser, "app.data.AppUser", ({
  j9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppUser as $d_Lapp_data_AppUser };
//# sourceMappingURL=app.data.-App-User.js.map
